export const API_URL = 'https://api.thesnuslife.com';
export const ENVIRONMENT = 'development';
export const instId = '1476888';
export const currency = 'GBP';
export const WEB_URL = 'https://thesnuslife.com';
export const GATEWAY_MARCHANT_ID = 'BCR2DN4TQ2VKFICO';
export const GATEWAY_ENTITY_ID = '8ac9a4c79362dc14019362edcb44013e';
export const GATEWAY_SUCCESS_CODE = '000.000.000';
